import { render, staticRenderFns } from "./ModerationPolicyNew.vue?vue&type=template&id=d82ba45a"
var script = {}
import style0 from "./ModerationPolicyNew.vue?vue&type=style&index=0&id=d82ba45a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports